/* eslint-disable react/no-array-index-key */
import { ColorSystemNegative3, Spacing4 } from 'autogen/design-tokens/tokens';
import type { BasketValidationError } from 'autogen/swagger/all';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';
import Card from 'components/generic/card';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import format from 'helpers/translations';
import styled from 'styled-components';

const StyleCard = styled(Card)`
    background-color: #fdeeef;
`;

export default function BasketErrors({ model: validationErrors }: { model: BasketValidationError[] }) {
    return (
        <>
            {validationErrors.map((error, index) => (
                <StyleCard key={index}>
                    <Card.Content>
                        <Flex.Column gap={Spacing4} alignItems="start">
                            <WithIcon icon={<Icon type="Alert" size={24} fill={ColorSystemNegative3} />}>
                                <Typography.Title size="S">{error.headline}</Typography.Title>
                            </WithIcon>
                            <Typography.Body as="span">{format(error.text)}</Typography.Body>
                        </Flex.Column>
                    </Card.Content>
                </StyleCard>
            ))}
        </>
    );
}
